import { render, staticRenderFns } from "./ProcessEnergyList.vue?vue&type=template&id=684424e6&"
import script from "./ProcessEnergyList.vue?vue&type=script&lang=js&"
export * from "./ProcessEnergyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports